module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAWBAMAAADp1AsXAAAAIVBMVEUAAAD////////////////////////////////////////PIev5AAAACnRSTlMAgPAQoHDg0MCwNuNxSAAAADpJREFUCNdjQABmp1WrQLT5KgjtBaWzoPSqVZMZILQAEs20CggWMTBwrQIBTJpVcNWqRlGYenJpOAAAox8nriP4Cb8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/facebook_white.png
// module id = 27
// module chunks = 1